
import img1 from '../imgs/image1.png';
import img2 from '../imgs/image2.jpg';
import img3 from '../imgs/world pic.png';

import { ViewItem } from "./home"


export default function Features(){

    return (
        <div id="features">
            <div className='max' style={{gap: "50px"}}>
                {
                    features.map( (feature, i) => <Feature key={i} data={feature} /> )
                }
            </div>
        </div>
    )
}


function Feature({data}){
    const {img, alt, main, sub} = data;

    return (
        <ViewItem>
            <div className='feat fw'>
                <div className="fw flex-col sdq mid-align" style={{padding: "30px 0", gap: "20px"}}>
                    <div className="feat-img fw">
                        <img src={img} alt={alt} className='br-1 fw' style={{objectFit: "cover"}} />
                    </div>
                    <div className="feat-txt">
                        <h4> {main} </h4>
                        <p> {sub} </p>
                    </div>
                </div>
            
            </div>
        </ViewItem>
    )
}


const features = [
    {
        img: img1,
        main: <>Synergy of <br></br> Methods</>,
        sub: <>
            By combining several scientifically proven effective study methods, <br></br>
            <span style={{ fontSize: "125%", padding: "2px" }}> LearnXcess </span> utilizes this comprehensive approach to <br></br>
            enhance learning and ensure retention.
        </>
    },
    {
        img: img2,
        main: <>Personalized Support</>,
        sub: <>
            Feel de-motivated to study sometimes? We can help! <br></br>
            The Chatbot provides personalized guidance and <br></br>
            de-mystifies confusing areas in a way streamlined to <br></br> your optimal learning method.
        </>
    },
    {
        img: img3,
        main: <> Collaborative Community & <br></br> Study Groups </>,
        sub: <>
            Join groups of our ever-growing community and <br></br> connect with learners from across the world, <br></br>
            Keep your motivation levels soaring <br></br>
            Add your friends to study groups and support each other to success.
        </>
    }
]